"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _QuestionEntityRecord = _interopRequireDefault(require("../QuestionEntityRecord"));

var PropertyTextInput = function PropertyTextInput(_ref) {
  var question = _ref.question,
      _onChange = _ref.onChange,
      disabled = _ref.disabled;
  var TextInput = question.propertyFieldType === 'textarea' ? _UITextArea.default : _UITextInput.default;
  var extraInputProps = question.propertyFieldType === 'textarea' ? {
    resize: disabled ? false : 'vertical'
  } : {};
  return _react.default.createElement(TextInput, (0, _extends2.default)({
    value: question.getValue() || '',
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.propertyPlaceholders.textInput')
  }, extraInputProps));
};

PropertyTextInput.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired
};
var _default = PropertyTextInput;
exports.default = _default;
module.exports = exports.default;